/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";
import FooterLinks from "../footerLinks/footerLinks";
import "./globalFooter.scss";

const GlobalFooter = ({ links, copyrightText, dataTestId, ...props }) => (
  <div
    data-testid={dataTestId}
    className={gatherClasses(props, "oui-global-footer-container")}
  >
    <FooterLinks links={links} />
    {copyrightText && (
      <div>
        <span dangerouslySetInnerHTML={{ __html: "&copy;" }} /> {copyrightText}
      </div>
    )}
  </div>
);

GlobalFooter.propTypes = {
  className: PropTypes.string,
  copyrightText: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.oneOf(["_blank", "_self", "_parent", "_top"]),
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      renderComponent: PropTypes.func
    })
  ),
  dataTestId: PropTypes.string
};

GlobalFooter.defaultProps = {
  className: "",
  copyrightText: "",
  links: [],
  dataTestId: "orion-global-footer"
};

GlobalFooter.displayName = "OrionGlobalFooter";

export default GlobalFooter;
